import React, { useEffect, useState } from 'react';
import { FaProjectDiagram, FaUsers, FaTrophy, FaClock } from 'react-icons/fa';
import './Stats.css';

const Stats = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [counts, setCounts] = useState({
    projects: 0,
    clients: 0,
    awards: 0,
    experience: 0
  });

  const finalCounts = {
    projects: 500,
    clients: 200,
    awards: 25,
    experience: 5
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          startCounting();
        }
      },
      { threshold: 0.5 }
    );

    const element = document.querySelector('.stats-grid');
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  const startCounting = () => {
    const duration = 2000; // 2 seconds
    const intervals = {
      projects: setInterval(() => {
        setCounts(prev => {
          const increment = Math.ceil(finalCounts.projects / (duration / 50));
          const newValue = Math.min(prev.projects + increment, finalCounts.projects);
          if (newValue >= finalCounts.projects) clearInterval(intervals.projects);
          return { ...prev, projects: newValue };
        });
      }, 50),

      clients: setInterval(() => {
        setCounts(prev => {
          const increment = Math.ceil(finalCounts.clients / (duration / 50));
          const newValue = Math.min(prev.clients + increment, finalCounts.clients);
          if (newValue >= finalCounts.clients) clearInterval(intervals.clients);
          return { ...prev, clients: newValue };
        });
      }, 50),

      awards: setInterval(() => {
        setCounts(prev => {
          const increment = Math.ceil(finalCounts.awards / (duration / 50));
          const newValue = Math.min(prev.awards + increment, finalCounts.awards);
          if (newValue >= finalCounts.awards) clearInterval(intervals.awards);
          return { ...prev, awards: newValue };
        });
      }, 50),

      experience: setInterval(() => {
        setCounts(prev => {
          const increment = Math.ceil(finalCounts.experience / (duration / 50));
          const newValue = Math.min(prev.experience + increment, finalCounts.experience);
          if (newValue >= finalCounts.experience) clearInterval(intervals.experience);
          return { ...prev, experience: newValue };
        });
      }, 50)
    };
  };

  const stats = [
    {
      icon: <FaProjectDiagram />,
      number: counts.projects,
      suffix: '+',
      label: 'Projects Complete',
      description: 'Successfully delivered projects'
    },
    {
      icon: <FaUsers />,
      number: counts.clients,
      suffix: '+',
      label: 'Happy Customers',
      description: 'Satisfied clients worldwide'
    },
    {
      icon: <FaTrophy />,
      number: counts.awards,
      suffix: '+',
      label: 'Awards & Recognition',
      description: 'Industry achievements'
    },
    {
      icon: <FaClock />,
      number: counts.experience,
      suffix: '+',
      label: 'Years Experience',
      description: 'In digital solutions'
    }
  ];

  return (
    <section className="stats-section section-padding">
      <div className="stats-background">
        <div className="stats-overlay"></div>
      </div>

      <div className="container">
        <div className="section-title">
          <span className="section-subtitle">Our Achievements</span>
          <h2>Numbers That Speak Our Success</h2>
          <p>
            These numbers reflect our commitment to excellence and the trust
            our clients place in our digital solutions.
          </p>
        </div>
        <div className={`stats-grid ${isVisible ? 'visible' : ''}`}>
          {stats.map((stat, index) => (
            <div
              key={index}
              className="stat-card"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="stat-icon">{stat.icon}</div>
              <div className="stat-content">
                <div className="stat-number">
                  {stat.number}
                  <span className="stat-suffix">{stat.suffix}</span>
                </div>
                <h3 className="stat-label">{stat.label}</h3>
                <p className="stat-description">{stat.description}</p>
              </div>
              <div className="stat-decoration"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
